import { Reveal } from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "No shortcuts. No fluff.",
    body: "Every program is built on progressive overload, honest effort and consistency. We measure what matters and adjust it weekly — no cookie-cutter plans, no guesswork.",
  },
  {
    n: "02",
    title: "Strength is a skill.",
    body: "Technique first, ego last. You'll learn to move well before you move heavy, so you build power that lasts and stays injury-free for the long game.",
  },
  {
    n: "03",
    title: "The squad carries you.",
    body: "Bootcamps turn solo grind into shared fire. Accountability, energy and competition push you further than you'd ever go alone.",
  },
];

export default function Manifesto() {
  return (
    <section id="method" className="bg-[#050505] py-24 md:py-40" data-testid="manifesto">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <Reveal>
          <p className="font-mono-accent text-[#005EEA] text-xs mb-4">The Method</p>
          <h2 className="font-display text-white text-5xl md:text-7xl lg:text-8xl leading-[0.9] max-w-4xl">
            How we build champions
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-28 flex flex-col gap-16 md:gap-40">
          {chapters.map((c) => (
            <div key={c.n} className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10">
              <div className="md:col-span-4">
                <div className="md:sticky md:top-32">
                  <span className="font-display text-[22vw] md:text-[10vw] leading-none text-transparent [-webkit-text-stroke:1.5px_#222]">
                    {c.n}
                  </span>
                </div>
              </div>
              <div className="md:col-span-7 md:col-start-6 flex items-center">
                <Reveal>
                  <h3 className="font-display text-white text-3xl md:text-5xl leading-none mb-6">{c.title}</h3>
                  <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed max-w-xl">{c.body}</p>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
